import { AuthenticationType } from '@/store/SiteSurveyForm/constants';

export const getAmplifyConfig = (authType: string, webUrl: string) => {
  if (authType === AuthenticationType.SSO) {
    return {
      region: import.meta.env.VITE_AMPLIFY_REGION ?? 'us-east-1',
      userPoolId: import.meta.env.VITE_AMPLIFY_SSO_USER_POOL_ID,
      userPoolWebClientId: import.meta.env.VITE_AMPLIFY_SSO_USER_POOL_WEB_CLIENT_ID,
      oauth: {
        domain: import.meta.env.VITE_AMPLIFY_OAUTH_DOMAIN,
        redirectSignIn: `${webUrl}/login/sso`,
        redirectSignOut: `${webUrl}/login/sso`,
        responseType: 'code',
      },
    };
  } else {
    return {
      region: import.meta.env.VITE_AMPLIFY_REGION ?? 'us-east-1',
      userPoolId: import.meta.env.VITE_AMPLIFY_USER_POOL_ID,
      userPoolWebClientId: import.meta.env.VITE_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
      mandatorySignIn: true,
      authenticationFlowType: 'USER_PASSWORD_AUTH',
    };
  }
}